import { auth } from "../firebase";

let cachedOffset = 0; 
let hasInitialized = false;
let lastFetchTime = 0;
let inFlightPromise = null;
let lastFailTime = 0;

const CACHE_DURATION = 5 * 60 * 1000;
const FAIL_COOLDOWN = 10 * 1000;
const TIMEOUT_MS = 5000;

function fetchWithTimeout(url, options = {}, timeout = TIMEOUT_MS) {
  const controller = new AbortController();
  const timeoutId = setTimeout(() => controller.abort(), timeout);

  return fetch(url, {
    ...options,
    signal: controller.signal,
  }).finally(() => clearTimeout(timeoutId));
}

export default async function getServerOffset() {
  const now = Date.now();

  if (hasInitialized && now - lastFetchTime < CACHE_DURATION) {
    return cachedOffset;
  }

  if (now - lastFailTime < FAIL_COOLDOWN && hasInitialized) {
    return cachedOffset;
  }

  if (inFlightPromise) {
    return inFlightPromise;
  }

  inFlightPromise = (async () => {
    try {
      // 1. Get the current user
      const user = auth.currentUser;
      if (!user) {
        throw new Error("No user authenticated");
      }

      // 2. Get a fresh Token
      const token = await user.getIdToken();

      const res = await fetchWithTimeout(
        "https://gettime-5dhfwyjvzq-uc.a.run.app/",
        { 
          method: "GET",
          headers: {
            // 3. Attach the token to fix the 401
            "Authorization": `Bearer ${token}`
          }
        }
      );

      if (res.status === 401) {
        throw new Error("Unauthorized: Check if your token is valid");
      }

      if (res.status === 429) {
        lastFailTime = Date.now();
        console.warn("getServerOffset: rate limited (429)");
        return cachedOffset;
      }

      if (!res.ok) {
        throw new Error(`Server responded with ${res.status}`);
      }

      const data = await res.json();

      if (typeof data?.time !== "number") {
        throw new Error("Invalid server response format");
      }

      cachedOffset = data.time - Date.now();
      lastFetchTime = Date.now();
      hasInitialized = true;

      return cachedOffset;
    } catch (err) {
      console.error("getServerOffset failed:", err.message);

      if (err.name !== "AbortError") {
        lastFailTime = Date.now();
      }

      return cachedOffset;
    } finally {
      inFlightPromise = null;
    }
  })();

  return inFlightPromise;
}